import { css } from 'styled-components';

const styles = css`
  width: 100%;
  background-color: transparent;
`;

export default styles;
export { styles };
